import { render, staticRenderFns } from "./main.vue?vue&type=template&id=6d24f979"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d24f979')) {
      api.createRecord('6d24f979', component.options)
    } else {
      api.reload('6d24f979', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=6d24f979", function () {
      api.rerender('6d24f979', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalLoading/main.vue"
export default component.exports